import { useContext } from 'react'
import { OverridesContext } from '../context/OverridesContext'

export const useOverridesContext = <T extends string>() => {
  return useContext(OverridesContext) as Record<T, string> | null
}
